import type { Article, ArticleMeta } from '../types'
import { article as adventNaChalupe } from './advent-na-chalupe'
import { article as blueMonday } from './blue-monday'
import { article as chalupaDoHodinyZPrahy } from './chalupa-do-hodiny-z-prahy'
import { article as dovolenaSDetmi } from './dovolena-s-detmi'
import { article as dovolenaSePsem } from './dovolena-se-psem'
import { article as glamping } from './glamping'
import { article as jakFungujeLastMinute } from './jak-funguje-last-minute-ubytovani'
import { article as jarniPrazdniny2027 } from './jarni-prazdniny-2027'
import { article as kamUtectPredVedrem } from './kam-utect-pred-vedrem'
import { article as kdeVidetMlecnouDrahu } from './kde-videt-mlecnou-drahu'
import { article as narodChaluparu } from './narod-chaluparu'
import { article as pobytNaHorach } from './pobyt-na-horach'
import { article as pobytSBazenem } from './pobyt-s-bazenem'
import { article as pobytSKadi } from './pobyt-s-kadi'
import { article as pobytSVirivkou } from './pobyt-s-virivkou'
import { article as pobytUVody } from './pobyt-u-vody'
import { article as podzimNaChalupe } from './podzim-na-chalupe'
import { article as praceZChalupy } from './prace-z-chalupy'
import { article as prodlouzenyVikendNaChalupe } from './prodlouzeny-vikend-na-chalupe'
import { article as procJeDobreSaunovani } from './proc-je-dobre-saunovani'
import { article as romantikaUKrbu } from './romantika-u-krbu'
import { article as romantickyPobytVeDvou } from './romanticky-pobyt-ve-dvou'
import { article as silvestrNaChalupe } from './silvestr-na-chalupe'
import { article as strasidelnaMistaCeska } from './strasidelna-mista-ceska'
import { article as svatyMartinHusaAVino } from './svaty-martin-husa-a-vino'
import { article as vanocniMytyAPravdy } from './vanocni-myty-a-pravdy'
import { article as zimniRekordyCeska } from './zimni-rekordy-ceska'

/**
 * Registry of all published articles. Add a new article by creating its data
 * module under this folder and appending it here. The build scripts (sitemap,
 * prerender, Amplify rules) read this registry directly — no API involved.
 */
const articles: Article[] = [
  adventNaChalupe,
  blueMonday,
  chalupaDoHodinyZPrahy,
  dovolenaSDetmi,
  dovolenaSePsem,
  glamping,
  jakFungujeLastMinute,
  jarniPrazdniny2027,
  kamUtectPredVedrem,
  kdeVidetMlecnouDrahu,
  narodChaluparu,
  pobytNaHorach,
  pobytSBazenem,
  pobytSKadi,
  pobytSVirivkou,
  pobytUVody,
  podzimNaChalupe,
  praceZChalupy,
  prodlouzenyVikendNaChalupe,
  procJeDobreSaunovani,
  romantikaUKrbu,
  romantickyPobytVeDvou,
  silvestrNaChalupe,
  strasidelnaMistaCeska,
  svatyMartinHusaAVino,
  vanocniMytyAPravdy,
  zimniRekordyCeska,
]

/** Articles ordered newest first by publish date. */
const sortedArticles: Article[] = [...articles].sort((a, b) => b.meta.publishedAt.localeCompare(a.meta.publishedAt))

/**
 * An article with a future `publishedAt` is scheduled: it stays out of the
 * list, the sitemap and its own URL until that day (Prague time). Pages are
 * server-rendered per request, so it goes live without a deploy. The dev
 * server shows scheduled articles too, so they can be reviewed before release.
 */
function isPublished(meta: ArticleMeta): boolean {
  if (import.meta.env.DEV) return true
  const today = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Prague',
  }).format(new Date())
  return meta.publishedAt <= today
}

export function getArticleMetas(): ArticleMeta[] {
  return sortedArticles.map((article) => article.meta).filter((meta) => isPublished(meta))
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((article) => article.meta.slug === slug && isPublished(article.meta))
}
